import { default as domainDynamicTimeBalance } from './balance/services' 

export default { 
	domainDynamicTimeBalance
}
